import axiosInstance from '../../config/axiosInstance';
import { ORGANIZATIONS_LIST_PAGE_SIZE } from '../../constants/organization';
import {
  CreateOrganizationPayload,
  OrganizationListResponse,
  OrganizationV2,
  UpdateOrganizationPayload,
} from '../../types/organization';

export class OrganizationService {
  private readonly ORGANIZATIONS_PATH = '/organizations';

  async list(
    page = 1,
    pageSize = ORGANIZATIONS_LIST_PAGE_SIZE,
    search?: string,
  ): Promise<OrganizationListResponse> {
    return axiosInstance.get(this.ORGANIZATIONS_PATH, {
      params: { page, pageSize, search: search || undefined },
    });
  }

  async getMy(): Promise<OrganizationV2> {
    return axiosInstance.get(`${this.ORGANIZATIONS_PATH}/my`);
  }

  async get(id: string): Promise<OrganizationV2> {
    return axiosInstance.get(`${this.ORGANIZATIONS_PATH}/${id}`);
  }

  async create(payload: CreateOrganizationPayload): Promise<OrganizationV2> {
    return axiosInstance.post(this.ORGANIZATIONS_PATH, payload);
  }

  async update(
    id: string,
    payload: UpdateOrganizationPayload,
  ): Promise<OrganizationV2> {
    return axiosInstance.patch(`${this.ORGANIZATIONS_PATH}/${id}`, payload);
  }

  async setMonobankToken(token: string): Promise<OrganizationV2> {
    return axiosInstance.put(`${this.ORGANIZATIONS_PATH}/my/monobank-token`, {
      token,
    });
  }

  async removeMonobankToken(): Promise<OrganizationV2> {
    return axiosInstance.delete(`${this.ORGANIZATIONS_PATH}/my/monobank-token`);
  }
}

export const organizationService = new OrganizationService();
